import { useListSubmissionsBySite } from 'api/resource';
import { useListPayors } from 'api/resource/payor';
import { useCurrentSiteStore } from 'store/SiteStore';

export const useAdminSubmissionManagementData = () => {
  const { id: siteID } = useCurrentSiteStore();
  const submissionsResult = useListSubmissionsBySite({ siteID });
  const payorsResult = useListPayors();

  const isLoading = submissionsResult.isLoading || payorsResult.isLoading;
  const isError = submissionsResult.isError || payorsResult.isError;
  const isFetching = submissionsResult.isFetching || payorsResult.isFetching;
  const errorMessage =
    submissionsResult.error?.message || payorsResult.error?.message;

  return {
    submissions: submissionsResult.data || [],
    payors: payorsResult.data || [],
    isLoading,
    isError,
    isFetching,
    errorMessage,
  };
};
